import { NavigateFunction } from 'react-router-dom';
import { StepIndicatorNames } from '../../../types';
import { fetchProjectDetails } from '../projectHandlers';

export const createNavigationHandlers = (
  navigate: NavigateFunction,
  projectId: string,
  audioUrl: string | null,
  mediaItems: any[],
  openTitleModal: (type: string, url?: string, projectId?: string, titleData?: any) => void,
  openThumbnailModal: (config: any) => void,
  setIsModalOpen: (open: boolean) => void,
  showNotification: (notification: any) => void,
  project: any
) => {
  return async (key: StepIndicatorNames) => {
    if (key === StepIndicatorNames.AudioGeneration) {
      let currentAudioUrl = audioUrl;

      if (projectId && currentAudioUrl) {
        navigate(`/audio-editor/${projectId}?audioUrl=${encodeURIComponent(currentAudioUrl)}`);
      } else if (projectId) {
        try {
          const projectData = await fetchProjectDetails(projectId);
          if (projectData) {
            const projectAudioUrl = projectData.finalAudio || projectData.originalAudioUrl;
            if (projectAudioUrl) {
              navigate(`/audio-editor/${projectId}?audioUrl=${encodeURIComponent(projectAudioUrl)}`);
            } else {
              navigate('/audio-generation');
            }
          } else {
            navigate('/audio-generation');
          }
        } catch (error) {
          navigate('/audio-generation');
        }
      } else {
        navigate('/audio-generation');
      }
    }
    else if (key === StepIndicatorNames.SoundGeneration) {
      if (projectId) {
        navigate(`/sound-editor/${projectId}`);
      } else {
        navigate('/sound-generation');
      }
    }
    else if (key === StepIndicatorNames.ContentCreation) {
      if (projectId) {
        try {
          const projectData = await fetchProjectDetails(projectId);
          if (projectData && projectData.originalAudioUrl) {
            const queryParams = new URLSearchParams();
            queryParams.append('project-id', projectId);
            queryParams.append('audio-url', projectData.originalAudioUrl);
            
            if (projectData.generatedVideoUrl || projectData.originalVideoUrl) {
              const videoUrl = projectData.generatedVideoUrl || projectData.originalVideoUrl;
              queryParams.append('video-url', videoUrl);
            }
            
            navigate(`/create-content?${queryParams.toString()}`);
          } else {
            navigate('/create-content');
          }
        } catch (error) {
          navigate('/create-content');
        }
      } else {
        navigate('/create-content');
      }
    }
    else if (key === StepIndicatorNames.CaptionCreation) {
      if (mediaItems && mediaItems.length > 0) {
        setIsModalOpen(true);
      } else {
        showNotification({ 
          type: 'info', 
          message: 'Please add some media items first before generating captions',
          title: 'Info'
        });
      }
    }
    else if (key === StepIndicatorNames.TitleDescTag) {
      if (audioUrl) {
        openTitleModal('audio', audioUrl, projectId, project?.titleData);
      } else {
        openTitleModal('none', undefined, projectId, project?.titleData);
      }
    } 
    else if (key === StepIndicatorNames.ThumbnailCreation) {
      if (audioUrl) {
        openThumbnailModal({
          projectId,
          mediaUrl: audioUrl,
          mediaType: 'audio',
          hasExistingCaptions: false
        });
      } else {
        openThumbnailModal({
          projectId,
          mediaType: 'none',
          hasExistingCaptions: false
        });
      }
    }
    else if (key === StepIndicatorNames.ScriptGeneration) {
      if (projectId) {
        navigate(`/script-generator/${projectId}`);
      } else {
        navigate('/script-generator');
      }
    }
    else if (key === StepIndicatorNames.IdeaCreation) {
      if (projectId) {
        navigate(`/prompt-generator/${projectId}`);
      } else {
        navigate('/prompt-generator');
      }
    }
    else if (key === StepIndicatorNames.Export) {
      console.log('Export step selected');
    }
  };
};
